import React, { useEffect, useState } from 'react';
import { X, UserCheck, Download } from 'lucide-react';
import axios from '../../configApi/axiosConfig';
import { APIURL } from '../../configApi/apiConfig';
import { ClientesAprobadosDetalle } from './ClientesAprobadosDetalle';
import { exportarClientesAprobadosExcel } from './utils/exportarClientesAprobadosExcel';

export function ClientesAprobadosModal({ idVendedor, nombreVendedor, onClose }) {
  const [estado, setEstado] = useState({ loading: true, error: null, data: [] });

  useEffect(() => {
    if (!idVendedor) return;
    setEstado({ loading: true, error: null, data: [] });
    axios.get(APIURL.getCumplimientoVentasVendedorClientesAprobados(idVendedor))
      .then(res => setEstado({ loading: false, error: null, data: Array.isArray(res.data) ? res.data : [] }))
      .catch(() => setEstado({ loading: false, error: 'Error al cargar el detalle de créditos.', data: [] }));
  }, [idVendedor]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4" onClick={onClose}>
      <div
        className="flex max-h-[80vh] w-full max-w-3xl flex-col rounded-2xl bg-white shadow-xl"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4">
          <div className="flex items-center gap-2">
            <UserCheck size={18} className="text-morado" />
            <div>
              <h2 className="text-sm font-bold text-slate-800">Clientes aprobados / pre-aprobados</h2>
              <p className="text-xs text-slate-500">{nombreVendedor}</p>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <button
              onClick={() => exportarClientesAprobadosExcel(estado.data, `ClientesAprobados_${nombreVendedor || idVendedor}`)}
              disabled={estado.loading || estado.data.length === 0}
              className="flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-semibold text-morado hover:bg-morado/10 disabled:cursor-not-allowed disabled:text-slate-300 disabled:hover:bg-transparent"
              title="Exportar a Excel"
            >
              <Download size={14} /> Exportar
            </button>
            <button onClick={onClose} className="rounded-lg p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600">
              <X size={16} />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-4">
          <ClientesAprobadosDetalle estado={estado} />
        </div>
      </div>
    </div>
  );
}
